import { UW_SUCCESS_STATUS_CODE } from './axios-interceptor';

/** The underwriting engine's own response envelope: success is the body statusCode, not the HTTP status. */
export interface UeEnvelope<T> {
    success: boolean;
    statusCode: number;
    statusMsg?: string;
    message?: string;
    data: T;
}

/** The engine answers a Cerberus rejection with HTTP 200 and body statusCode 401, so success is the body code only. */
export function unwrapUeResponse<T>(res: { data?: UeEnvelope<T> } | undefined): { ok: true; data: T } | { ok: false } {
    return res?.data?.statusCode === UW_SUCCESS_STATUS_CODE ? { ok: true, data: res.data.data as T } : { ok: false };
}
